export enum PermissionTypes {
  DELAYED_STOCKS = 'DELAYED_STOCKS',
  RT_STOCKS = 'RT_STOCKS',
  EOD_FUTURES = 'EOD_FUTURES',
  RT_FUTURES = 'RT_FUTURES'
}
